
import mgPageData from "../../data/managedServices";
import {
  mgUses,
  uses,
  scrubbingCenter,
  saveDataSolution,
  cloudSecurity,
  services,
  abalonPopularServices,
  questions,
} from "../../data/organizationalSolutions";
import Customers from "../../components/organizationalSolution/CustomersEnterprise.vue";
import Modal from "../../components/rebranding/modal/Modal.vue";
import levelsServices from "../../components/managedServices/levelsServices.vue";
import issues from "../../components/managedServices/issues.vue";
import os from "../../components/managedServices/os.vue";
import Uses from "../../components/organizationalSolution/uses.vue";
export default {
  components: {
    Customers,
    Modal,
    levelsServices,
    issues,
    os,
    Uses,
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "خدمات یکپارچه و مقیاس‌پذیر‌ | راهکارهای سازمانی آبالون ",
      meta: [
        {
          name: "description",
          content:
            "راهکارهای سازمانی آبالون | خدمات یکپارچه و مقیاس‌پذیر بدون پیچیدگی | از زیرساخت تا ذخیره‌سازی با همراهی با تیم DevOps آبالون",
        },
        {
          property: "og:description",
          content:
            "راهکارهای سازمانی آبالون | خدمات یکپارچه و مقیاس‌پذیر بدون پیچیدگی | از زیرساخت تا ذخیره‌سازی با همراهی با تیم DevOps آبالون ",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/enterprise-solutions",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "خدمات یکپارچه و مقیاس‌پذیر‌ | راهکارهای سازمانی آبالون ",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/enterprise-solutions",
        },
        {
          name: "twitter:creator",
          content: "@themetrades",
        },
        {
          name: "twitter:title",
          content: "خدمات یکپارچه و مقیاس‌پذیر‌ | راهکارهای سازمانی آبالون ",
        },
        {
          name: "twitter:description",
          content:
            "راهکارهای سازمانی آبالون | خدمات یکپارچه و مقیاس‌پذیر بدون پیچیدگی | از زیرساخت تا ذخیره‌سازی با همراهی با تیم DevOps آبالون ",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/enterprise-solutions",
        },
      ],
    };
  },
  data() {
    return {
      title: "آبالون: ارائه دهنده سرویس‌های ابری",
      FormTitle: "ثبت درخواست ارتباط با واحد فروش",
      benefits: mgPageData.benefits,
      dataBlog: mgPageData.dataBlog,
      questions: mgPageData.questions,
      uses: uses,
      scrubbingCenter: scrubbingCenter,
      activeSection: "",
      operationSystems: mgPageData.operationSystems,
      ranges: mgPageData.ranges,
      mgUses: mgUses,
      cloudSecurity: cloudSecurity,
      saveDataSolution: saveDataSolution,
      cdnCoverage: services,
      PopularServices: abalonPopularServices,
      questions: questions,
      valid: true,
      first_name: "",
      first_nameRules: [(v) => !!v || "نام الزامی است"],
      last_name: "",
      last_nameRules: [(v) => !!v || " نام خانوادگی الزامی است"],
      mobile: "",
      mobileRules: [
        (v) => !!v || "شماره همراه الزامی است",
        (v) => /(\0)?9\d{9}/.test(v) || "شماره همراه باید معتبر باشد",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "ایمیل الزامی است",
        (v) => /.+@.+\..+/.test(v) || "ایمیل معتبر نمی باشد",
      ],
      company: "",
      companyRules: [(v) => !!v || "نام شرکت الزامی است"],
      semat: "",
      sematRules: [(v) => !!v || " سمت الزامی است"],
      plans: [],
    };
  },
  mounted() {
    this.getPlans();
  },
  methods: {
    spliceNumber(number) {
      if (number != null) {
        number = Math.round(number);
        return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
    },
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
    customizePlan() {
      for (let value of this.data.plan)
        if (this.request.price != value.price) {
          delete this.request.plan;
          this.selectedPlan = null;
        }
    },
    async getPlans() {
      const plans = await this.$axios.$get("api/v1/managedservice/plan");
      this.plans = plans.data;
    },
    async submitForm() {
      if (this.$refs.form.validate()) {
        let payload = {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          mobile: this.mobile,
          description: "شرکت : " + this.company + " سمت :" + this.semat,
        };

        try {
          let response = await this.$axios.$post(
            `api/v1/managedservice/request`,
            payload
          );
          if (response.success) {
            this.$toasted.success("درخواست شما با موفقیت ثبت شد!", {
              theme: "bubble",
              position: "top-right",
              duration: 1500,
            });
          }
        } catch (error) {
          this.$toasted.error("مشکلی در درخواست شما پیش آمد", {
            theme: "bubble",
            position: "top-right",
            duration: 1500,
          });
        }

        this.clear();
      }
    },

    clear() {
      this.first_name = "";
      this.last_name = "";
      this.mobile = "";
      this.email = "";
      this.semat = "";
      this.company = "";
      this.reset();
      this.resetValidation();
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
